<div
  class="invitation-tracker-statistics-scroll tw-flex tw-items-start tw-gap-2 lg:tw-gap-3 tw-w-[calc(100%+6px)] -tw-m-[3px] tw-p-[3px] tw-overflow-x-auto tw-font-inter"
  [attr.aria-busy]="isSkeleton() || null"
  [attr.aria-label]="isSkeleton() ? 'Loading invitation statistics' : 'Invitation statistics'"
>
  @for (card of cards(); track card.key) {
    @if (isSkeleton()) {
      <div class="tw-shrink-0 tw-w-[155px] tw-h-[58px] tw-rounded-lg tw-bg-gray-200 tw-animate-pulse lg:tw-flex-1 lg:tw-w-auto lg:tw-min-w-[174px] lg:tw-h-[70px] lg:tw-rounded-[10px]"></div>
    } @else if (card.isClickable) {
      <button type="button" [ngClass]="card.cardClass" [attr.aria-pressed]="card.isSelected" (click)="onCardClick(card.key)">
        <app-invitation-tracker-statistic-card-content [card]="card" />
      </button>
    } @else {
      <div [ngClass]="card.cardClass">
        <app-invitation-tracker-statistic-card-content [card]="card" />
      </div>
    }
  }
</div>
